(() => {
  const getVariantId = () => {
    const input = document.querySelector('form[action*="/cart/add"] [name="id"]');
    return input?.value ? String(input.value) : null;
  };

  const refreshInventoryBlocks = async (variantId) => {
    const containers = document.querySelectorAll('[id^="InventoryBlock-"]');
    if (!containers.length) return;

    await Promise.all(
      Array.from(containers).map(async (container) => {
        const sectionId = container.id.replace('InventoryBlock-', '');
        if (!sectionId) return;

        const url = new URL(window.location.href);
        url.searchParams.set('variant', variantId);
        url.searchParams.set('section_id', sectionId);

        try {
          const res = await fetch(url.toString(), { credentials: 'same-origin' });
          if (!res.ok) return;

          const html = await res.text();
          const doc = new DOMParser().parseFromString(html, 'text/html');
          const next = doc.querySelector(`#InventoryBlock-${CSS.escape(sectionId)}`);

          if (next) container.replaceWith(next);
        } catch {
          // no-op
        }
      })
    );
  };

  // ✅ The Ski Hero-proof part: detect variant changes by watching the hidden variant id input
  let lastVariantId = null;

  const tick = () => {
    const vid = getVariantId();
    if (vid && vid !== lastVariantId) {
      lastVariantId = vid;
      refreshInventoryBlocks(vid);
    }
    window.requestAnimationFrame(tick);
  };

  // start
  tick();
})();
